import React from 'react';
import moment from 'moment';
import { withNamespaces } from 'react-i18next';

const TravelDateDetail = ({ request, isManager ,t}) => (
  <div className="content table-responsive table-full-width">
    <table className="table table-hover table-bordered">
      <tbody>
        {
          isManager
            ? (
              <tr>
                <td>
                    {t("nameAndSurname")}
                </td>
                <td className="travelDetailEmployeeName">
                  {request.employee && request.employee.employeeName}
                </td>
              </tr>
            )
            : null
      }

        <tr>
          <td>
              {t("travelStartDate")}
          </td>
          <td className="travelDetailTravelStartDateAndHour">
            {moment(new Date(request.travelStartDate)).format('DD-MM-YYYY')}
            {' '}
            {request.travelStartHour}
          </td>
        </tr>
        <tr>
          <td>
              {t("travelEndDate")}
          </td>
          <td className="travelDetailTravelEndDateAndHour">
            {moment(new Date(request.travelEndDate)).format('DD-MM-YYYY')}
            {' '}
            {request.travelEndHour}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default withNamespaces()(TravelDateDetail);



// WEBPACK FOOTER //
// ./src/components/travel-expense/detail/date/index.js